import { PasswordErrMsg, PasswordRegExp } from '../utils/constants';
export interface passwordObj {
  upper: boolean;
  lower: boolean;
  num: boolean;
  min: boolean;
  special: boolean;
}

export const CheckPasswordCriteria = (passwordInputValue: string) => {
  const passwordLength = passwordInputValue.length;
  const uppercasePassword =
    PasswordRegExp.uppercaseRegExp.test(passwordInputValue);
  const lowercasePassword =
    PasswordRegExp.lowercaseRegExp.test(passwordInputValue);
  const digitsPassword = PasswordRegExp.digitsRegExp.test(passwordInputValue);
  const minLengthPassword =
    PasswordRegExp.minLengthRegExp.test(passwordInputValue);
  const specialCharPassword =
    PasswordRegExp.specialCharRegExp.test(passwordInputValue);
  let errMsg = '';
  let isStrongPassword: boolean;
  if (passwordLength === 0) {
    errMsg = PasswordErrMsg.empty;
    isStrongPassword = false;
  } else if (!uppercasePassword) {
    errMsg = PasswordErrMsg.upperCase;
    isStrongPassword = false;
  } else if (!lowercasePassword) {
    errMsg = PasswordErrMsg.lowerCase;
    isStrongPassword = false;
  } else if (!digitsPassword) {
    errMsg = PasswordErrMsg.digits;
    isStrongPassword = false;
  } else if (!minLengthPassword) {
    errMsg = PasswordErrMsg.minCharacter;
    isStrongPassword = false;
  } else if (!specialCharPassword) {
    errMsg = PasswordErrMsg.specialChar;
    isStrongPassword = false;
  } else {
    errMsg = PasswordErrMsg.strongPassword;
    isStrongPassword = true;
  }

  return { errMsg, isStrongPassword };
};

export const PasswordCriteriaMarking = async (passwordInputValue: string) => {
  const uppercasePassword =
    PasswordRegExp.uppercaseRegExp.test(passwordInputValue);
  const lowercasePassword =
    PasswordRegExp.lowercaseRegExp.test(passwordInputValue);
  const digitsPassword = PasswordRegExp.digitsRegExp.test(passwordInputValue);
  const minLengthPassword =
    PasswordRegExp.minLengthRegExp.test(passwordInputValue);
  const specialCharPassword =
    PasswordRegExp.specialCharRegExp.test(passwordInputValue);
  return {
    upper: uppercasePassword,
    lower: lowercasePassword,
    num: digitsPassword,
    min: minLengthPassword,
    special: specialCharPassword,
  };
};
